export const HOTEL_LIST_STORE = 'hotels-list-store';
export const HOTELS_LIST_FILTERS_STORE = 'hotels-list-filters-store';
export const HOTEL_CARD_RATES_FILTER_STORE = 'hotel-card-rates-filter-store';
